---
id: db-api
title: DB API service
owner: Backend Team
status: Active
lastReviewed: 2026-01-30
visibility: internal
tags:
  - db-api
  - postgres
  - microservice
---

## Product Overview

### Who it serves

This service provides a centralized data API for internal services that need to read and write core product data.

### Primary workflow

Internal callers issue CRUD and query requests across resumes, enterprise users, subscriptions, job posts, and related entities through the DB API endpoints.

### Business rules

Endpoints apply entity-specific validation and expose internal and enterprise scoped operations without frontend-facing presentation logic.

### Outcomes

Product services can store and retrieve normalized data through a single data-access layer backed by Postgres.

### Out of scope

User-facing business workflows, UI, and external integrations are handled outside this service.

### API documentation

[Internal API Documentation](https://wiki.rezi.ai/apis/db-api-api-docs)

## Technical Overview

### Architecture flow

Routes defined in `apps/micro-services/db-api/pkg/api/routes/routes.go` bind Gin handlers to controller methods that orchestrate service and repository calls.

### Entry points

- Controllers under `apps/micro-services/db-api/pkg/api/controllers` handle request validation and call service logic for each domain area such as resumes, enterprise users, subscriptions, job posts, and search history.
- The OpenAPI spec generator entry point is `apps/micro-services/db-api/cmd/spec/main.go`.

### Key modules

Postgres repositories live in `apps/micro-services/db-api/pkg/repo/sql/postgres`, while domain services in `apps/micro-services/db-api/pkg/services` manage business-specific data operations.

### Data sources and sinks

The service persists all data in PostgreSQL, initialized at startup by `apps/micro-services/db-api/pkg/adaptors/databases`.

### Integrations and side effects

The API acts as a shared data layer for other microservices and includes internal endpoints for data sync and cross-service operations.

### Constraints and risks

Availability depends on Postgres connectivity and schema compatibility across the large set of API surfaces.

## Changelog

- 2026-01-30: Added the OpenAPI spec generator entry point.
- 2026-01-30: Initial documentation.
